import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PrescricaoTemplateService } from 'src/app/services/prescricao-template.service';
import { ToastrService } from 'ngx-toastr';
import { PrescricaoTemplate } from 'src/app/models/prescricao-template.model';

@Component({
  selector: 'app-prescricao-template-modal',
  templateUrl: './prescricao-template-modal.component.html',
  styleUrls: ['./prescricao-template-modal.component.scss']
})
export class PrescricaoTemplateModalComponent implements OnInit {
  @Input() numConselho!: string; // <--- MUDOU PARA STRING
  @Input() textoAtual: string = '';

  templates: PrescricaoTemplate[] = [];
  novoTitulo: string = '';
  modoSalvar: boolean = false;
  loading: boolean = false;
  conteudoVisual: string = '';
  filtroPesquisa: string = '';

  templateEmEdicao: PrescricaoTemplate | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private templateService: PrescricaoTemplateService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    if (this.numConselho) {
      this.carregarTemplates();
    } else {
      this.toastr.error("Identificação do médico (CRM) não encontrada.");
      this.activeModal.dismiss();
    }
  }

  carregarTemplates() {
    this.loading = true;
    this.templateService.getTemplatesDoMedico(this.numConselho).subscribe({
      next: (res) => {
        // Verifica se sua API retorna direto o array ou um objeto { success: true, data: [] }
        // Ajuste aqui conforme seu BaseController
        this.templates = res.data || res || []; 
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.toastr.error('Erro ao carregar modelos.');
      }
    });
  }

  usarTemplate(template: PrescricaoTemplate) {
    this.activeModal.close({ acao: 'usar', conteudo: template.conteudo });
  }

  get templatesFiltrados() {
    if (!this.filtroPesquisa) {
      return this.templates;
    }
    const termo = this.filtroPesquisa.toLowerCase();
    return this.templates.filter(t => t.titulo.toLowerCase().includes(termo));
  }

  iniciarSalvamento() {
    // if (!this.textoAtual || this.textoAtual.trim() === '') {
    //   this.toastr.warning('O campo de prescrição está vazio.');
    //   return;
    // }

    this.templateEmEdicao = null;
    this.novoTitulo = '';
    
    // Inicia vazio visualmente
    this.conteudoVisual = this.textoAtual;
    this.textoAtual = '';
    this.modoSalvar = true;
  }

  editarTemplate(item: PrescricaoTemplate) {
    this.templateEmEdicao = item; // Guarda quem estamos editando
    this.novoTitulo = item.titulo; // Carrega o título
    this.textoAtual = item.conteudo; // Carrega o conteúdo para edição
    this.modoSalvar = true; // Abre a tela de form
    this.conteudoVisual = item.conteudo;
  }

  confirmarSalvamento() {
    if (!this.novoTitulo) {
      this.toastr.warning('Digite um título para o modelo.');
      return;
    }

    this.loading = true;

    // Cenário A: EDIÇÃO (PUT)
    if (this.templateEmEdicao) {
      const modeloAtualizado: PrescricaoTemplate = {
        ...this.templateEmEdicao, // Mantém ID e outros dados
        titulo: this.novoTitulo,
        conteudo: this.textoAtual
      };

      this.templateService.atualizarTemplate(modeloAtualizado).subscribe({
        next: () => {
          this.toastr.success('Modelo atualizado com sucesso!');
          this.finalizarAcao();
        },
        error: () => {
          this.loading = false;
          this.toastr.error('Erro ao atualizar modelo.');
        }
      });
    } 
    // Cenário B: CRIAÇÃO (POST)
    else {
      const novoModelo: PrescricaoTemplate = {
        numConselho: this.numConselho,
        titulo: this.novoTitulo,
        conteudo: this.textoAtual,
        status: true
      };

      this.templateService.salvarTemplate(novoModelo).subscribe({
        next: () => {
          this.toastr.success('Modelo criado com sucesso!');
          this.finalizarAcao();
        },
        error: () => {
          this.loading = false;
          this.toastr.error('Erro ao criar modelo.');
        }
      });
    }
  }

  finalizarAcao() {
    this.modoSalvar = false;
    this.templateEmEdicao = null;
    this.novoTitulo = '';
    this.carregarTemplates();
  }

  excluirTemplate(id: number | undefined) {
    if (!id) return;
    
    if(confirm('Tem certeza que deseja excluir este modelo?')) {
      this.templateService.excluirTemplate(id).subscribe({
        next: () => {
          this.toastr.success('Modelo excluído.');
          this.carregarTemplates();
        },
        error: () => this.toastr.error('Erro ao excluir.')
      });
    }
  }

  atualizarConteudo(event: any) {
    // Pega o HTML visual que está dentro da div e joga na variável
    this.textoAtual = event.target.innerHTML;
  }
}